import React, { useEffect, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { useDispatch, useSelector } from "react-redux";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import InputKendoRct from "../../control-components/input/input";
import searchIcon from "../../assets/images/search.png";
import { Switch } from "@progress/kendo-react-inputs";
import ErrorHelper from "../../helper/error-helper";
import { GET_ALL_CLINIC } from "../../actions";

const SearchModel = ({ fetchFromParent, onClear, setLoading }) => {
  const dispatch = useDispatch();
  const [allClinic, setAllClinic] = useState([]);
  const [errors, setErrors] = useState("");
  const [staffError, setStaffError] = useState(false);

  const [fields, setFields] = useState({
    masterClinicId: "",
    staffId: "",
    userName: "",
    email: "",
    fName: "",
    lName: ""
  });

  useEffect(() => {
    getAllClinic();
  }, []);

  const getAllClinic = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.ALL_CLINIC)
      .then((result) => {
        dispatch({
          type: GET_ALL_CLINIC,
          payload: result.resultData,
        });
        setLoading(false);
        let staffAuditActions = result.resultData;
        setAllClinic(staffAuditActions);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setFields({
      ...fields,
      [name]: value,
    });
  };



  const handleSearch = () => {
    onClear();
    setLoading(true);
      const data = {
        masterClinicId: fields?.masterClinicId?.id,
        staffId: fields.staffId === "" ? 0 : fields.staffId,
        userName: fields.userName,
        email: fields.email,
        firstName: fields.fName,
        lastName: fields.lName
      };
    if(!data.masterClinicId && !data.staffId && ! data.userName && ! data.email  && ! data.firstName  && ! data.lastName){
      return
    }

      ApiHelper.postRequest(ApiUrls.GET_STAFF, data)
        .then((result) => {
          setLoading(false);
          fetchFromParent(result.resultData);
        })
        .catch((error) => {
          setLoading(false);
          NotificationManager.error(error.message);
        });
  };

  const handleClear = () => {
    setFields({
      masterClinicId: "",
      staffId: "",
      searchContent: "",
      isActive: false,
      fName: "",
      lName: "",
      userName: "",
      email: "",
    });
    onClear();
  };
  return (
    <>

      <div class="col-md-12 col-sm-12 ">
        <div class="row ">
          <div className="col-md-12 col-lg-3 col-12 mb-3 edit-Service-popup">
            <DropDownKendoRct
              validityStyles={staffError}
              label="Master Clinic Name"
              onChange={handleChange}
              data={allClinic}
              value={fields.masterClinicId}
              textField="clinicName"
              name="masterClinicId"
              error={fields.masterClinicId === "" && errors.masterClinicId}
              required={true}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={fields.staffId}
              onChange={handleChange}
              name="staffId"
              label="Staff ID"
              className="form-control"
              placeholder={"Enter to search by staff ID"}
              type="number"
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={fields.userName}
              onChange={handleChange}
              name="userName"
              label="Username"
              className="form-control"
              placeholder={"Enter to search by username"}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={fields.email}
              onChange={handleChange}
              name="email"
              label="Email"
              className="form-control"
              placeholder={"Enter to search by email"}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={fields.fName}
              onChange={handleChange}
              name="fName"
              label="First Name"
              className="form-control"
              placeholder={"Enter to search by first name"}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={fields.lName}
              onChange={handleChange}
              name="lName"
              label="Last Name"
              className="form-control"
              placeholder={"Enter to search by last name"}
            />
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 mt-3">
        <div class="row">
          <div class="col-md-12">
            <div className="btn-align-cus d-flex justify-content-start ">
              <button className="green-btn btn-primary" onClick={handleSearch}>
                Filter
              </button>
              <button
                className="btn text-grey ml-3"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchModel;
